import { get } from 'lodash';
import moment from 'moment';
import calcShortcutInterval from '../calcShortcutInterval';
import { TOOLTIP_LABEL_FORMAT } from '../constants';

const CUSTOM = 'custom';

export function showRollingWindow(interval) {
  const { shortcut = CUSTOM } = interval;
  return shortcut !== CUSTOM;
}

function updateRollingInterval(interval) {
  const { shortcut = CUSTOM } = interval;

  if(shortcut !==  CUSTOM) {
    const [from, to] = calcShortcutInterval(shortcut);
    return {
      ...interval,
      from: from.format(),
      to: to.format(),
    }
  }
  return interval;
}

// mutates input state
export function updateRollingIntervalForTrends(payload) {
  try {
    const rollingWindow = get(payload, ['config', 'meta', 'rollingWindow'], false);
      const commonState = get(payload, ['config', 'state', 'common'], {});
      if('interval' in commonState) {
        if(rollingWindow) {
          // update window
          commonState.interval = updateRollingInterval(commonState.interval);
        }
        else {
          // change shortcut to custom
          commonState.interval= {...commonState.interval, shortcut: CUSTOM }
        }
      }
  } catch (err) {
    // console.error(err);
  }
}

// generates interval preview string for user
function formatInterval(interval, rollingWindow) {
  const { shortcut = CUSTOM } = interval;
  if(rollingWindow || shortcut ===  CUSTOM) {
    return shortcut;
  }

  const { from, to } = interval;
  return `${moment(from).format(TOOLTIP_LABEL_FORMAT)} - ${moment(to).format(TOOLTIP_LABEL_FORMAT)}`;
}

// different dashboards have different interval path
const defaultGetInterval = (config) => get(config, ['state', 'common', 'interval'],  null);
const intervalPathFn = {
  trends: defaultGetInterval,
}

export function extractIntervalFromConfig({ pageMeta, config, rollingWindow }) {
  const pageKey = get(pageMeta, ['page', 'key'], 'default');
  const getInterval = intervalPathFn[pageKey] || defaultGetInterval;
  const interval = getInterval(config);
  return formatInterval(interval, rollingWindow);
}
